import update from 'immutability-helper';
import { PROGRESS, SUCCESS, FAILED } from "../config/types";
import {
  WEBINARS_GET_LIST_PROGRESS,
  WEBINARS_GET_LIST_SUCCESS,
  WEBINARS_GET_LIST_FAILED,
  WEBINARS_FORM_SUBMIT_PROGRESS,
  WEBINARS_FORM_SUBMIT_SUCCESS,
  WEBINARS_FORM_SUBMIT_FAILED,
  WEBINARS_GET_WEBINAR_PROGRESS,
  WEBINARS_GET_WEBINAR_SUCCESS,
  WEBINARS_GET_WEBINAR_FAILED,
  WEBINARS_CLEAR_STATE,
} from '../actions/WebinarsAction';

const initialState = {
  loadListStatus: '', // progress/success/failed
  loadActiveStatus: '', // progress/success/failed
  submitStatus: '', // progress/success/failed
  list: [],
  pagination: {},
  active: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case WEBINARS_GET_LIST_PROGRESS: {
      return update(
        state, {
          list: { $set: [] },
          pagination: { $set: {} },
          loadListStatus: { $set: PROGRESS },
        },
      );
    }
    case WEBINARS_GET_LIST_SUCCESS: {
      return update(
        state, {
          list: { $set: action.payload.list },
          pagination: { $set: action.payload.pagination },
          loadListStatus: { $set: SUCCESS },
        },
      );
    }
    case WEBINARS_GET_LIST_FAILED: {
      return update(
        state, {
          list: { $set: [] },
          pagination: { $set: {} },
          loadListStatus: { $set: FAILED },
        },
      );
    }
    case WEBINARS_FORM_SUBMIT_PROGRESS: {
      return update(
        state,
        { submitStatus: { $set: PROGRESS } },
      );
    }
    case WEBINARS_FORM_SUBMIT_SUCCESS: {
      return update(
        state,
        {
          submitStatus: { $set: SUCCESS },
        },
      );
    }
    case WEBINARS_FORM_SUBMIT_FAILED: {
      return update(
        state,
        { submitStatus: { $set: FAILED } },
      );
    }
    case WEBINARS_GET_WEBINAR_PROGRESS: {
      return update(
        state, {
          active: { $set: {} },
          loadActiveStatus: { $set: PROGRESS },
        },
      );
    }
    case WEBINARS_GET_WEBINAR_SUCCESS: {
      return update(
        state, {
          active: { $set: action.payload },
          loadActiveStatus: { $set: SUCCESS },
        },
      );
    }
    case WEBINARS_GET_WEBINAR_FAILED: {
      return update(
        state, {
          active: { $set: {} },
          loadActiveStatus: { $set: FAILED },
        },
      );
    }
    case WEBINARS_CLEAR_STATE: {
      return update(
        state,
        {
          loadListStatus: { $set: '' },
          loadActiveStatus: { $set: '' },
          submitStatus: { $set: '' },
          list: { $set: [] },
          pagination: { $set: {} },
          active: { $set: {} },
        },
      );
    }
    default:
      return state;
  }
}
